<template>
  <div style="height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: 50px;margin: 0 20px">
      <el-date-picker v-fixZoom
        v-model="orderDate"
        type="daterange"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        value-format="yyyyMMdd"
        style="margin-right: 10px; width: 400px">
      </el-date-picker>
      <el-input
        prefix-icon="el-icon-search"
        placeholder="输入姓名搜索"
        v-model="searchKeyword"
        style="width: 350px"
        type="number"
        @blur="blurSearch">
      </el-input>
      <el-button type="primary" @click="queryOrderInfo()">查询</el-button>
      <el-button icon="el-icon-download" type="success" @click="getAllHistoryByDate">导出</el-button>
    </div>
    <div style="max-height: calc(100% - 71px);margin: 0 20px;overflow-y: auto;">
      <div style="max-height: calc(100% - 60px);overflow-y: auto;">
        <el-table
          :data="showTable"
          border
          style="width: 100%">
          <el-table-column
            type="index"
            label="序号"
            width="70"
            align="center">
          </el-table-column>
          <el-table-column
            prop="oname"
            label="姓名"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            prop="cellphone"
            label=" 手机号码"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            prop="address"
            label="地址"
            min-width="150"
            align="center">
          </el-table-column>
          <el-table-column
            prop="name"
            label="服务类型"
            min-width="140px">
            <template slot-scope="scope">
<!--              <span>{{getSupplier(scope.row.substid, 2)}}</span>-->
            </template>
          </el-table-column>
          <el-table-column
            prop="tm"
            label="订单时间"
            min-width="140"
            align="center">
          </el-table-column>
          <el-table-column
            label="接单人"
            min-width="80"
            align="center">
            <template slot-scope="scope">
              {{getUser(scope.row.firsthandle_suid)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="firsthandle_tm"
            label="接单时间"
            min-width="140"
            align="center">
          </el-table-column>
          <el-table-column
            min-width="80"
            align="center">
            <template slot-scope="scope">
              {{getUser(scope.row.overhandle_suid)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="overhandle_tm"
            label="结单时间"
            min-width="140">
          </el-table-column>
          <el-table-column
            label="订单状态"
            min-width="100">
            <template slot-scope="scope">
              <!--0 未处理 1 已接单 2 已完成 3 已退单-->
              <span>{{getStatusOrder(scope.row.tag)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="处理详情" width="120"  class-name="small-padding fixed-width">
            <template slot-scope="scope">
<!--              <img style="cursor: pointer;width: 28px" src="../../assets/company/icon_handle.png" @click="openDetailsShow(scope.row)">-->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCells">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'companyOrder',
  data () {
    return {
      searchKeyword: '',
      orderDate: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [{
          text: '最近一天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近30天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      showTable: []
    }
  },
  created () {
  },
  methods: {
    blurSearch () {},
    queryOrderInfo () {},
    getAllHistoryByDate () {},
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/statisticalform/companyOrder.vue